<script setup lang="ts">
const song = useSongStore();
const props = defineProps<{
  id?: string;
  icon: string;
  active?: boolean;
  showLabel?: boolean;
  label: string;
  showBusy?: boolean;
  disabled?: boolean;
}>();

const iconClasses = computed(() => {
  let classes = props.showBusy ? "fa-spin fa-spinner-third" : props.icon;

  classes += " fa-fw fa-light";
  return classes;
});
</script>

<template>
  <button
    :id="id"
    type="button"
    :class="{ active: active || showBusy }"
    :title="label"
    class="toolbar-button"
    :disabled="disabled || showBusy"
  >
    <FAIcon
      :class="iconClasses"
      class="fa-fw"
    />
    <span v-if="showLabel">{{ label }}</span>
  </button>
</template>

<style scoped lang="postcss"></style>
